/*
	For panes that scroll sideways only, with no visible scrollbar.

	When the content exactly fills such a pane its height is usually fractional, and browsers round
	the scrollport down. iOS Safari then clips that last fraction of a pixel, swallowing bottom
	borders and descenders. The vertical padding gives the rounding somewhere to land.
	::-webkit-scrollbar covers Safari versions predating scrollbar-width, where the overlay
	scrollbar sits over that same bottom edge.
*/
export const sidewaysScroll = {
	overflowX: 'auto',
	overflowY: 'hidden',
	paddingTop: 1,
	paddingBottom: 1,
	scrollbarWidth: 'none',

	'&::-webkit-scrollbar': {
		display: 'none'
	}
} as const;
